import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useRecoilState, useRecoilValue } from "recoil";
import { receiptStepState } from "../../recoil/pageStep";
import {
  firstAnswerState,
  receiptSubmitState,
  secondAnswerState,
  thirdAnswerState,
} from "../../recoil/receipt";
import Button from "../atoms/buttons/Button";
import ButtonGroup from "../atoms/layout/ButtonGroup";
import StepBar from "../atoms/layout/StepBar";
import Question from "../atoms/Question";
import QuestionDual from "../atoms/QuestionDual";
import FooterButtonGroup from "../modules/layout/FooterButtonGroup";
import Header from "../modules/layout/Header";

const Survey = ({ visibility }) => {
  const {
    formState: { errors },
  } = useForm();
  const [receiptStep, setReceiptStep] = useRecoilState(receiptStepState);

  const [firstAnswer, setFirstAnswer] = useRecoilState(firstAnswerState);
  const [secondAnswer, setSecondAnswer] = useRecoilState(secondAnswerState);
  const [thirdAnswer, setThirdAnswer] = useRecoilState(thirdAnswerState);

  const [submitState, setSubmitState] = useRecoilState(receiptSubmitState);

  // 제출 버튼의 "submit" 속성 활성화
  useEffect(() => {
    setSubmitState("submit");
  }, []);

  return (
    <div style={{ display: visibility }}>
      <Header />
      <div className="base-sec">
        <div className="background-color-w">
          <div className="base-sec-sec">
            <div className="page-title text-align-center">
              <p>사전 서베이</p>
            </div>
            <StepBar step={2} />
            <div className="cen-944">
              <p className="agree-title">사전 서베이</p>
              <div className="cont-border servey-cont">
                <div className="text-align-center mb-60">
                  <span
                    style={{
                      color: "gray",
                      margin: "auto",
                    }}
                  >
                    선택하신 사전 서베이를 통한 개인별 맞춤형 문제가 출제됩니다.
                    <br />
                  </span>
                </div>
                <div className="servey-q">
                  <div className="servey-q-title text-align-center">
                    <p>사전 서베이</p>
                  </div>
                  <Question
                    title="1. 현재 귀하는 어느 분야에 종사하고 계십니까?"
                    answers={[
                      "대학(원)생 - 구직활동 하지 않음",
                      "취업 준비생(대학(원)생 포함)",
                      "사업자/직장인",
                    ]}
                    name="first_question"
                    state={firstAnswer}
                    setState={setFirstAnswer}
                  />
                  <Question
                    title="2. 현재 귀하는 누구와 살고 계십니까?"
                    answers={[
                      "홀로 거주",
                      "친구나 룸메이트와 함께 거주",
                      "가족(배우자/자녀/기타 가족일원)과 함께 거주",
                    ]}
                    name="second_question"
                    state={secondAnswer}
                    setState={setSecondAnswer}
                  />
                  <QuestionDual
                    title="3. 귀하는 여가 활동, 취미·관심사로 주로 무엇을 하십니까? (2개 선택)"
                    answers={[
                      "운동(조깅/걷기/등산, 자전거, 야구, 농구, 배구, 축구, 골프, 테니스 등)",
                      "문화생활(영화, TV, 연극, 콘서트, 박물관 등)",
                      "SNS 활동 (블로그, 인스타그램, 카톡, YouTube 등)",
                      "여행 (국내·외)",
                      "게임 (전통적인 게임부터 컴퓨터 및 스마트폰 게임 등)",
                      "예술 활동 (미술, 음악 감상, 악기 연주 등)",
                      "자기개발 (독서, 재태크, 관련 강의 수강, 스터디, 동아리 활동 등)",
                      "자기관리 (패션, 메이크업, 쇼핑 등)",
                    ]}
                    name="third_question"
                    state={thirdAnswer}
                    type="checkbox"
                    setState={setThirdAnswer}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="base-sec-bottom">
            <ButtonGroup>
              <Button
                className="bottombtn bottombtn-w"
                size="lg"
                color="secondary"
                type="button"
                onClick={() => {
                  setReceiptStep(receiptStep - 1);
                }}
              >
                취소
              </Button>
              {submitState ? (
                <Button
                  className="bottombtn bottombtn-b"
                  size="lg"
                  color="primary"
                  type="submit"
                >
                  확인
                </Button>
              ) : (
                <Button
                  className="bottombtn bottombtn-b"
                  size="lg"
                  color="primary"
                  type="button"
                >
                  확인
                </Button>
              )}
            </ButtonGroup>
          </div>
          {/* <FooterButtonGroup
            prevOnClick={() => {
              setReceiptStep(receiptStep - 1);
            }}
            nextButtonType={submitState}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default Survey;
